<template>
  <div class="page-business-intelligence-emitter-performance">
    <BIEmitterSummary :dates="dates" @on-date-changed="updateDateRange" @on-edit-clicked="onEditClicked" />
    <BITenders
      :dates="dates"
      :emitterId="emitterId"
      :hasTenderChanged="hasTenderChanged"
      @tender-clicked="onTenderClicked"
    />
    <TenderDetailsDialog ref="tenderDetailsDialog" :tender="selectedTender" @on-tender-changed="onTenderChanged" />
    <EmitterFormDialog ref="emitterFormDialog" @action-succeeded="onEdited" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import EmitterFormDialog from '@/views/business-intelligence/EmitterFormDialog.vue';
import BIEmitterSummary from '@/components/page-business-intelligence/BIEmitterSummary.vue';
import BITenders from '@/components/page-business-intelligence/BITenders.vue';
import TenderDetailsDialog from '@/components/page-business-intelligence/TenderDetailsDialog.vue';
import { getStartOfYear, getToday } from '@/util/date-util';

export default {
  name: 'PageBIEmitterPerformance',
  components: {
    BIEmitterSummary,
    BITenders,
    TenderDetailsDialog,
    EmitterFormDialog,
  },
  computed: {
    ...mapGetters('biDashboard', { emitter: 'emitter', savedDates: 'dates' }),
  },
  data() {
    return {
      dates: [getStartOfYear(), getToday()], // Default to current year
      emitterId: this.$route.params.emitterId,
      selectedTender: null,
      hasTenderChanged: false,
    };
  },
  methods: {
    ...mapActions('biDashboard', ['getEmitter', 'setDates']),
    updateDateRange(dates) {
      this.setDates(dates);
      this.dates = dates;
    },
    onTenderClicked(tender) {
      this.selectedTender = tender;
      this.hasTenderChanged = false;
      this.$refs.tenderDetailsDialog.openDialog();
    },
    onTenderChanged() {
      this.hasTenderChanged = true;
    },
    onEditClicked() {
      this.$refs.emitterFormDialog.open(this.emitter || { id: this.emitterId });
    },
    onEdited() {
      // aliases may have changed: the summary and the tenders depend on them
      this.getEmitter(this.emitterId);
      this.dates = [...this.dates];
    },
  },
  created() {
    this.getEmitter(this.emitterId);
    if (this.savedDates && this.savedDates.length === 2) {
      this.dates = this.savedDates;
    }
  },
};
</script>

<style lang="scss">
.page-business-intelligence-emitter-performance {
  padding: 32px;

  // Phones: the screen's gutter, and a tender drawer no wider than the screen.
  @include screen-below('tablet') {
    padding: $phone-page-gutter;

    .__tender-drawer {
      min-width: 0;
    }
  }

  .__tender-drawer {
    min-width: 450px;
  }
}
</style>
